module.exports = __webpack_public_path__ + "31ee192569ca4a60c8fde8b643d01b9a.png";